var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.6,4C9.3,4,8.9,4.1,8.6,4.2C9.1,3.8,9.6,3.5,10,3.3c0.4-0.1,0.7-0.1,0.8,0l0.5-0.5C10.8,2.4,10.1,2,9.3,2 C8.3,2,7.5,2.5,7,3.2C6.5,2.5,5.7,2,4.7,2C3.9,2,3.2,2.3,2.7,2.9l0.5,0.5c0.1-0.1,0.5-0.2,0.8,0c0.5,0.2,0.9,0.5,1.4,0.9 C5.1,4.1,4.7,4,4.4,4C2.8,4,1.5,5.3,1.5,6.9h0.6c0-0.4,0.9-0.9,2.2-1C4,6.1,3.8,6.3,3.6,6.5c-1.1,1.1-1.1,3,0,4.1L4,10.2 C3.7,9.9,4,8.8,4.9,7.9c0.9-0.9,1.6-1,1.7-1l0.7,0c0.1,0,0.8,0.1,1.7,1c0.9,0.9,1.2,2,0.9,2.3l0.5,0.5c1.1-1.1,1.1-3,0-4.1 C10.2,6.3,9.9,6.1,9.7,6c1.3,0,2.2,0.5,2.2,1h0.6C12.5,5.3,11.2,4,9.6,4z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9,10.4L7.9,12l-1.9-0.4l0.1-1.1H7.9z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2,9.8h1.7l0-0.6H6.2L6.2,9.8z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4,7.6l-0.1,0l-0.5,0l-0.1,0c-0.1,0-0.2,0.1-0.3,0.1l0,0.8h1.5l0-0.8C7.6,7.6,7.5,7.6,7.4,7.6z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacation);
export default __webpack_public_path__ + "static/media/vacation.5762f76e.svg";
export { ForwardRef as ReactComponent };